import { NavigateFunction } from "react-router-dom";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { UserRowTransactions, RowTransactions, PricingRow, UserRow, UserTranstionRow, BillingRow } from "./types";
import React from "react";
import { Tag } from "antd";
import i18n from "i18next";
import { StationCodes } from "pages/stationCodes/StationCodes";
import { Transactions as TypeTransactionsPage } from "pages/transactions/Transactions";
import settingSvg from 'assets/setting.svg';
import { Button } from "antd";
import {StationCodesRow} from "./types";

type Sort = {
	sessions: boolean,
	energyInKWH: boolean,
	revenue: boolean
};

type SortTransactions = {
	startTime: boolean,
	endTime: boolean,
	length: boolean,
	energy: boolean,
	revenue?: boolean,
	numJobs?: boolean,
	statementDate?: boolean,
};

type Transactions = {
	startTime: boolean,
	endTime: boolean,
	energy: boolean,
	revenue: boolean,
};

export const computeRowsAndCols = (
	data: StationCodes,
	navigate: NavigateFunction,
	handleSort: (value: string) => void,
	shouldReset: (value: boolean) => void,
	reset: boolean,
	isAsc: Sort,
	isDesc: Sort,
	setIsAsc: (values: () => Sort) => void,
	setIsDesc: (values: () => Sort) => void) => {

	if (!data.length) {
		return {
			columns: [],
			rows: []
		};
	}

	const handleFilterChange = (field: string) => {
		if (!isAsc[field]) {
			setIsAsc(() => {
				const setSort = { sessions: false, energyInKWH: false, revenue: false };
				setSort[field] = true;
				return { ...setSort };
			});
			handleSort(field + "_asc");
			setIsDesc(() => {
				return { sessions: false, energyInKWH: false, revenue: false };
			});
		} else if (!isDesc[field] && isAsc[field]) {
			setIsAsc(() => {
				return { sessions: false, energyInKWH: false, revenue: false };
			});
			setIsDesc(() => {
				const setSort = { sessions: false, energyInKWH: false, revenue: false };
				setSort[field] = true;
				return { ...setSort };
			});
			handleSort(field + "_desc");
			shouldReset(false);
		}
	};

	const columns = [
		{
			title: <div className="table-header">Station</div>,
			dataIndex: "station",
			key: "station",
			align: "center" as const,
		},
		{
			title: <div className="table-header">Code</div>,
			dataIndex: "stationCode",
			key: "stationCode",
			align: "center" as const,
		},
		{
			title: <div className="table-header">Email</div>,
			dataIndex: "email",
			key: "email",
			align: "center" as const,
		},
		{
			title: <div className="table-header">Expire At</div>,
			dataIndex: "expireAt",
			key: "expireAt",
			align: "center" as const,
		},
		{
			title: <div className="table-header">Sessions</div>,
			dataIndex: "sessions",
			key: "sessions",
			align: "center" as const,
		},
		{
			title: <div className="table-header">Energy</div>,
			dataIndex: "energyInKWH",
			key: "energyInKWH",
			align: "center" as const,

		}
	];

	const rows: StationCodesRow[] = [];
	Object.keys(data).forEach((key, index) => {

		const values = data[key];
		rows.push({
			key: (rows.length + 1).toString(),
			station: values.station,
			stationCode: values.accessCode,
			email: values.email,
			expireAt: values.expireAt,
			energyInKWH: values.energyUsed,
			sessions: values.numJobs,
		});
	});



	return {
		columns: columns,
		rows: rows
	};
	

	

// export const computeRowsAndCols = (
// 	data: Users,
// 	navigate: NavigateFunction,
// 	handleSort: (value: string) => void,
// 	shouldReset: (value: boolean) => void,
// 	reset: boolean,
// 	isAsc: Sort,
// 	isDesc: Sort,
// 	setIsAsc: (values: () => Sort) => void,
// 	setIsDesc: (values: () => Sort) => void) => {

// 	if (!data.length) {
// 		return {
// 			columns: [],
// 			rows: []
// 		};
// 	}

// 	const handleFilterChange = (field: string) => {
// 		if (!isAsc[field]) {
// 			setIsAsc(() => {
// 				const setSort = { sessions: false, energyInKWH: false, revenue: false };
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_asc");
// 			setIsDesc(() => {
// 				return { sessions: false, energyInKWH: false, revenue: false };
// 			});
// 		} else if (!isDesc[field] && isAsc[field]) {
// 			setIsAsc(() => {
// 				return { sessions: false, energyInKWH: false, revenue: false };
// 			});
// 			setIsDesc(() => {
// 				const setSort = { sessions: false, energyInKWH: false, revenue: false };
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_desc");
// 			shouldReset(false);
// 		}
// 	};

// 	const columns = [
// 		{
// 			title: <div className="table-header">{i18n.t("users.userName")}</div>,
// 			dataIndex: "name",
// 			key: "name",
// 			align: "center" as const,
// 			render: (index, params) => {
// 				if (params) {
// 					return <a onClick={() =>
// 						navigate(`/users/${params.userId}`, {
// 							state: {
// 								locationIdStationId: params.group,
// 								status: params.status,
// 								userId: params.userId
// 							}
// 						})
// 					}
// 					>
// 						{index}
// 					</a>;
// 				}
// 				return <a>{index}</a>;
// 			},
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("Charger ID")}</div>,
// 			dataIndex: "chargerId",
// 			key: "chargerId",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("Active")}</div>,
// 			dataIndex: "active",
// 			key: "active",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">Station</div>,
// 			dataIndex: "station",
// 			key: "station",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("Priority Type")}</div>,
// 			key: "priorityType",
// 			dataIndex: "priorityType",
// 			align: "center" as const,
// 			render: (tag) => {
// 				let color = "#CECECE";
// 				if (tag === "Regular") {
// 					color = "#9DCC78";
// 				} else if (tag === "High") {
// 					color = "#E088FF";
// 				}
// 				return <Tag color={color} key={tag}>{tag.toUpperCase()}</Tag>;
// 			}
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.sessions")} {reset ?
// 				<CaretDownOutlined onClick={() => {
// 					handleFilterChange("sessions");
// 				}} /> : (!isDesc.sessions ?
// 					<CaretDownOutlined onClick={() => {
// 						handleFilterChange("sessions");
// 					}} /> :
// 					<CaretUpOutlined onClick={() => {
// 						handleFilterChange("sessions");
// 					}} />)}
// 			</div>,
// 			dataIndex: "sessions",
// 			key: "sessions",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("chargers.energy")} {reset ?
// 				<CaretDownOutlined onClick={() => {
// 					handleFilterChange("energyInKWH");
// 				}} /> : (!isDesc.energyInKWH ?
// 					<CaretDownOutlined onClick={() => {
// 						handleFilterChange("energyInKWH");
// 					}} /> :
// 					<CaretUpOutlined onClick={() => {
// 						handleFilterChange("energyInKWH");
// 					}} />)}
// 			</div>,
// 			dataIndex: "energyInKWH",
// 			key: "energyInKWH",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("chargers.revenue")} {reset ?
// 				<CaretDownOutlined onClick={() => {
// 					handleFilterChange("revenue");
// 				}} /> : (!isDesc.revenue ?
// 					<CaretDownOutlined onClick={() => {
// 						handleFilterChange("revenue");
// 					}} /> :
// 					<CaretUpOutlined onClick={() => {
// 						handleFilterChange("revenue");
// 					}} />)}
// 			</div>,
// 			dataIndex: "revenue",
// 			key: "revenue",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">Email</div>,
// 			dataIndex: "email",
// 			key: "email",
// 			align: "center" as const,
// 		},
// 	];

// 	const rows: UserRow[] = [];
// 	Object.keys(data).forEach((key, index) => {
// 		const values = data[key];

// 		rows.push({
// 			key: (rows.length + 1).toString(),
// 			userId: values.userId,
// 			name: values.name,
// 			chargerId: values.chargerId.toUpperCase(),
// 			active: values.active ? 'True' : 'False',
// 			group: values['locationId.stationId'],
// 			station: values.station,
// 			priorityType: values.priorityType,
// 			energyInKWH: values.energyInKWH,
// 			revenue: values.revenue,
// 			email: values.email,
// 			sessions: values.sessions
// 		});
// 	});

// 	return {
// 		columns: columns,
// 		rows: rows
// 	};
// };

// export const computeRowsAndColsForBilling = (
// 	data: UserTransactions,
// 	handleSort: (value: string) => void,
// 	isAsc: SortTransactions,
// 	isDesc: SortTransactions,
// 	setIsAsc: (values: () => SortTransactions) => void,
// 	setIsDesc: (values: () => SortTransactions) => void,
// ) => {

// 	if (!data.length) {
// 		return {
// 			columns: [],
// 			rows: []
// 		};
// 	}

// 	const handleSortChange = (field: string) => {
// 		if (!isAsc[field]) {
// 			setIsAsc(() => {
// 				const setSort = {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_asc");
// 			setIsDesc(() => {
// 				return {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 			});
// 		} else if (!isDesc[field] && isAsc[field]) {
// 			setIsAsc(() => {
// 				return {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 			});
// 			setIsDesc(() => {
// 				const setSort = {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_desc");
// 		}
// 	};

// 	const columns = [
// 		{
// 			title: <div className="table-header">{i18n.t("users.statementDate")}{!isDesc.statementDate ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("statementDate");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("statementDate");
// 				}} />}
// 			</div>,
// 			dataIndex: "statementDate",
// 			key: "statementDate",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.energy")}
// 			</div>,
// 			dataIndex: "energy",
// 			key: "energy",
// 			align: "center" as const,
// 			render: (_, tag) => {
// 				return <div>{tag.energy} {tag.energyUnit}</div>;
// 			}
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.sessions")}
// 			</div>,
// 			key: "numJobs",
// 			dataIndex: "numJobs",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.revenue")}{!isDesc.revenue ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("revenue");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("revenue");
// 				}} />}
// 			</div>,
// 			dataIndex: "revenue",
// 			key: "revenue",
// 			align: "center" as const,
// 		}
// 	];

// 	const rows: BillingRow[] = [];
// 	Object.keys(data).forEach((key, index) => {
// 		const values = data[key];

// 		rows.push({
// 			key: (rows.length + 1).toString(),
// 			energyUnit: values.energyUnit,
// 			statementDate: values.statementDate,
// 			energy: values.energy,
// 			numJobs: values.numJobs,
// 			revenue: values.revenue,
// 		});
// 	});

// 	return {
// 		columns: columns,
// 		rows: rows
// 	};
// };

// export const computeRowsAndColsForTransactionsandUsers = (
// 	data: UserTransactions,
// 	handleSort: (value: string) => void,
// 	isAsc: SortTransactions,
// 	isDesc: SortTransactions,
// 	setIsAsc: (values: () => SortTransactions) => void,
// 	setIsDesc: (values: () => SortTransactions) => void,
// ) => {

// 	if (!data.length) {
// 		return {
// 			columns: [],
// 			rows: []
// 		};
// 	}

// 	const handleSortChange = (field: string) => {
// 		if (!isAsc[field]) {
// 			setIsAsc(() => {
// 				const setSort = {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_asc");
// 			setIsDesc(() => {
// 				return {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 			});
// 		} else if (!isDesc[field] && isAsc[field]) {
// 			setIsAsc(() => {
// 				return {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 			});
// 			setIsDesc(() => {
// 				const setSort = {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_desc");
// 		}
// 	};

// 	const columns = [
// 		{
// 			title: <div className="table-header">{i18n.t("users.startTime")}{!isDesc.startTime ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("startTime");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("startTime");
// 				}} />}
// 			</div>,
// 			dataIndex: "startTime",
// 			key: "startTime",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.endTime")}{!isDesc.endTime ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("endTime");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("endTime");
// 				}} />}
// 			</div>,
// 			key: "endTime",
// 			dataIndex: "endTime",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.energy")}{!isDesc.energy ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("energy");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("energy");
// 				}} />}
// 			</div>,
// 			dataIndex: "energy",
// 			key: "energy",
// 			align: "center" as const,
// 			render: (_, tag) => {
// 				return <div>{tag.energy} {tag.energyUnit}</div>;
// 			}
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.length")}{!isDesc.length ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("length");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("length");
// 				}} />}
// 			</div>,
// 			dataIndex: "length",
// 			key: "length",
// 			align: "center" as const,
// 			render: (_, tag) => {
// 				return <div>{tag.length} {tag.lengthUnit}</div>;
// 			}
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.revenue")}{!isDesc.revenue ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("revenue");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("revenue");
// 				}} />}
// 			</div>,
// 			dataIndex: "revenue",
// 			key: "revenue",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("users.transactionId")}</div>,
// 			dataIndex: "transactionId",
// 			key: "transactionId",
// 			align: "center" as const,
// 		},
// 	];

// 	const rows: UserTranstionRow[] = [];
// 	Object.keys(data).forEach((key, index) => {
// 		const values = data[key];

// 		rows.push({
// 			key: (rows.length + 1).toString(),
// 			energyUnit: values.energyUnit,
// 			lengthUnit: values.lengthUnit,
// 			startTime: values.startTime,
// 			endTime: values.endTime,
// 			energy: values.energy,
// 			length: values.length,
// 			revenue: values.revenue,
// 			transactionId: values.transactionId,
// 		});
// 	});

// 	return {
// 		columns: columns,
// 		rows: rows
// 	};
// };

// export const computeRowsAndColsPricing = (
// 	data: Pricing,
// 	navigate: NavigateFunction,
// 	handleSort: (value: string) => void,
// 	shouldReset: (value: boolean) => void,
// 	reset: boolean,
// 	isAsc: Sort,
// 	isDesc: Sort,
// 	setIsAsc: (values: () => Sort) => void,
// 	setIsDesc: (values: () => Sort) => void,
// 	setEditModel,
// 	setEditModelData,
// 	users,
// 	setUsers,
// 	handleOpenPlan,
// 	setPricingRecord
// ) => {


// 	if (!data.length) {
// 		return {
// 			columns: [],
// 			rows: []
// 		};
// 	}


// 	const handleFilterChange = (field: string) => {
// 		if (!isAsc[field]) {
// 			setIsAsc(() => {
// 				const setSort = { sessions: false, energyInKWH: false, revenue: false };
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_asc");
// 			setIsDesc(() => {
// 				return { sessions: false, energyInKWH: false, revenue: false };
// 			});
// 		} else if (!isDesc[field] && isAsc[field]) {
// 			setIsAsc(() => {
// 				return { sessions: false, energyInKWH: false, revenue: false };
// 			});
// 			setIsDesc(() => {
// 				const setSort = { sessions: false, energyInKWH: false, revenue: false };
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_desc");
// 			shouldReset(false);
// 		}
// 	};

// 	const onMouseEnter = (record, paymentStatus) => {
// 	}

// 	const onMouseLeave = (record) => {
// 		// let newItems = [...users];
// 		// newItems = newItems.map((item, index) => {
// 		// 	if (record.key == index+1) {
// 		// 		item.isFlag = false;
// 		// 	}
// 		// 	item.isFlag = false;
// 		// 	return item;
// 		// })
// 		// setUsers(newItems);
// 	}

// 	const settingTap = (record) => {
// 		// setEditModel(true)
// 		let newItems = [...users];
// 		newItems = newItems.map((item, index) => {
// 			item.isFlag = !item.isFlag;
// 			return item;
// 		})
// 		setUsers(newItems);
// 		setEditModelData(record)
// 	}

// 	const planDCFCTap = (record) => {
// 		if (!record.isFlag) {
// 			setPricingRecord({ ...record, type: "DCFC" })
// 			handleOpenPlan()
// 		} else {
// 			setEditModel(true)
// 		}
// 	}

// 	const planLEVELTap = (record) => {
// 		if (!record.isFlag) {
// 			setPricingRecord({ ...record, type: "LEVEL" })
// 			handleOpenPlan()
// 		} else {
// 			setEditModel(true)
// 		}
// 	}

// 	const columns = [
// 		{
// 			title: <div className="table-header">{i18n.t("pricing.station")}</div>,
// 			dataIndex: "stationName",
// 			key: "stationName",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("priorityPricingPlan")}</div>,
// 			dataIndex: "priorityPricingPlan",
// 			key: "priorityPricingPlan",
// 			align: "center" as const,
// 			render: (ele, record) => {
// 				return (
// 					!record.isFlag ? (record.priorityPricingPlan == "N/A" ? <div>{record.priorityPricingPlan}</div> : <a onClick={() => planDCFCTap(record)} onMouseLeave={() => onMouseLeave(record)}>{record.priorityPricingPlan}</a>) : <Button type="dashed" size="small" onClick={() => planDCFCTap(record)} onMouseLeave={() => onMouseLeave(record)}>{record.priorityPricingPlan}</Button>
// 				)
// 			}
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("regularPricingPlan")}</div>,
// 			dataIndex: "regularPricingPlan",
// 			key: "regularPricingPlan",
// 			align: "center" as const,
// 			render: (ele, record) => {
// 				return (
// 					!record.isFlag ? (record.regularPricingPlan == "N/A" ? <div>{record.regularPricingPlan}</div> : <a onClick={() => planDCFCTap(record)}>{record.regularPricingPlan}</a>) : <Button type="dashed" size="small" onClick={() => planDCFCTap(record)} onMouseLeave={() => onMouseLeave(record)}>{record.regularPricingPlan}</Button>
// 				)
// 			}
// 		},
// 		// {
// 		// 	title: <div className="table-header">{i18n.t("pricing.title")}</div>,
// 		// 	dataIndex: "title",
// 		// 	key: "title",
// 		// 	align: "center" as const,
// 		// 	render: (_, tag) => {
// 		// 		return <img src={settingSvg} onClick={() => settingTap(tag)}></img>;
// 		// 	}
// 		// },
// 	];

// 	const rows: PricingRow[] = [];
// 	Object.keys(data).forEach((key, index) => {
// 		const values = data[key];

// 		rows.push({
// 			key: (rows.length + 1).toString(),
// 			station: values.station,
// 			stationName: values.stationName,
// 			priorityPricingPlan: values.priorityPricingPlan,
// 			regularPricingPlan: values.regularPricingPlan,
// 			title: '',
// 			isFlag: values.isFlag
// 		});
// 	});

// 	return {
// 		columns: columns,
// 		rows: rows
// 	};
// };

// export const computeRowsAndColsForTransactions = (
// 	data: UserTransactions,
// 	handleSort: (value: string) => void,
// 	isAsc: SortTransactions,
// 	isDesc: SortTransactions,
// 	setIsAsc: (values: () => SortTransactions) => void,
// 	setIsDesc: (values: () => SortTransactions) => void,
// ) => {

// 	if (!data.length) {
// 		return {
// 			columns: [],
// 			rows: []
// 		};
// 	}

// 	const handleSortChange = (field: string) => {
// 		if (!isAsc[field]) {
// 			setIsAsc(() => {
// 				const setSort = {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_asc");
// 			setIsDesc(() => {
// 				return {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 			});
// 		} else if (!isDesc[field] && isAsc[field]) {
// 			setIsAsc(() => {
// 				return {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 			});
// 			setIsDesc(() => {
// 				const setSort = {
// 					startTime: false,
// 					endTime: false,
// 					length: false,
// 					energy: false,
// 				};
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_desc");
// 		}
// 	};

// 	const columns = [
// 		{
// 			title: <div className="table-header">{i18n.t("user.transactionId")}</div>,
// 			dataIndex: "transactionId",
// 			key: "transactionId",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("user.station")}</div>,
// 			dataIndex: "locationIdStationId",
// 			key: "locationIdStationId",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("charger.startTime")}{!isDesc.startTime ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("startTime");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("startTime");
// 				}} />}
// 			</div>,
// 			dataIndex: "startTime",
// 			key: "startTime",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("charger.endTime")}{!isDesc.endTime ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("endTime");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("endTime");
// 				}} />}
// 			</div>,
// 			key: "endTime",
// 			dataIndex: "endTime",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("charger.length")}{!isDesc.length ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("length");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("length");
// 				}} />}
// 			</div>,
// 			dataIndex: "length",
// 			key: "length",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("charger.energy")}{!isDesc.energy ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("energy");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("energy");
// 				}} />}
// 			</div>,
// 			dataIndex: "energy",
// 			key: "energy",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("user.revenue")}{!isDesc.energy ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("revenue");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("revenue");
// 				}} />}
// 			</div>,
// 			dataIndex: "revenue",
// 			key: "revenue",
// 			align: "center" as const,
// 		}
// 	];

// 	const rows: UserRowTransactions[] = [];
// 	Object.keys(data).forEach(key => {
// 		const values = data[key];
// 		rows.push({
// 			key: (rows.length + 1).toString(),
// 			transactionId: values.transactionId,
// 			userId: values.userId,
// 			locationIdStationId: values.locationIdStationId,
// 			startTime: values.startTime,
// 			endTime: values.endTime,
// 			length: (values.length).toString() + " " + values.lengthUnit,
// 			energy: (values.energy).toString() + " " + values.energyUnit,
// 			revenue: values.revenue,
// 		});
// 	});

// 	return {
// 		columns: columns,
// 		rows: rows
// 	};
// };

// export const computeRowsAndColsForTransactionsPage = (
// 	data: TypeTransactionsPage,
// 	navigate: NavigateFunction,
// 	handleSort: (value: string) => void,
// 	shouldReset: (value: boolean) => void,
// 	reset: boolean,
// 	isAsc: Transactions,
// 	isDesc: Transactions,
// 	setIsAsc: (values: () => Transactions) => void,
// 	setIsDesc: (values: () => Transactions) => void) => {

// 	if (data.length === 0) {
// 		return {
// 			columns: [],
// 			rows: []
// 		};
// 	}

// 	const handleSortChange = (field: string) => {
// 		if (!isAsc[field]) {
// 			setIsAsc(() => {
// 				const setSort = {
// 					startTime: false,
// 					endTime: false,
// 					energy: false,
// 					revenue: false,
// 				};
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_asc");
// 			setIsDesc(() => {
// 				return {
// 					startTime: false,
// 					endTime: false,
// 					energy: false,
// 					revenue: false,
// 				};
// 			});
// 		} else if (!isDesc[field] && isAsc[field]) {
// 			setIsAsc(() => {
// 				return {
// 					startTime: false,
// 					endTime: false,
// 					energy: false,
// 					revenue: false,
// 				};
// 			});
// 			setIsDesc(() => {
// 				const setSort = {
// 					startTime: false,
// 					endTime: false,
// 					energy: false,
// 					revenue: false,
// 				};
// 				setSort[field] = true;
// 				return { ...setSort };
// 			});
// 			handleSort(field + "_desc");
// 		}
// 		shouldReset(false);
// 	};

// 	const columns = [
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.transactionId")}</div>,
// 			dataIndex: "transactionId",
// 			key: "transactionId",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.userId")}</div>,
// 			dataIndex: "userId",
// 			key: "userId",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.station")}</div>,
// 			dataIndex: "station",
// 			key: "station",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.chargerId")}</div>,
// 			dataIndex: "chargerId",
// 			key: "chargerId",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.type")}</div>,
// 			dataIndex: "type",
// 			key: "type",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.startTime")} {reset ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("startTime");
// 				}} /> : (!isDesc.startTime ?
// 					<CaretDownOutlined onClick={() => {
// 						handleSortChange("startTime");
// 					}} /> :
// 					<CaretUpOutlined onClick={() => {
// 						handleSortChange("startTime");
// 					}} />)}
// 			</div>,
// 			dataIndex: "startTime",
// 			key: "startTime",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.endTime")} {reset ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("endTime");
// 				}} /> : (!isDesc.endTime ?
// 					<CaretDownOutlined onClick={() => {
// 						handleSortChange("endTime");
// 					}} /> :
// 					<CaretUpOutlined onClick={() => {
// 						handleSortChange("endTime");
// 					}} />)}
// 			</div>,
// 			key: "endTime",
// 			dataIndex: "endTime",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.energy")} {reset ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("energy");
// 				}} /> : (!isDesc.energy ?
// 					<CaretDownOutlined onClick={() => {
// 						handleSortChange("energy");
// 					}} /> :
// 					<CaretUpOutlined onClick={() => {
// 						handleSortChange("energy");
// 					}} />)}
// 			</div>,
// 			key: "energy",
// 			dataIndex: "energy",
// 			align: "center" as const,
// 		},

// 		{
// 			title: <div className="table-header">{i18n.t("transactions.revenue")}{!isDesc.revenue ?
// 				<CaretDownOutlined onClick={() => {
// 					handleSortChange("revenue");
// 				}} /> :
// 				<CaretUpOutlined onClick={() => {
// 					handleSortChange("revenue");
// 				}} />}
// 			</div>,
// 			key: "revenue",
// 			dataIndex: "revenue",
// 			align: "center" as const,
// 		},
// 		{
// 			title: <div className="table-header">{i18n.t("transactions.pricingPlan")}</div>,
// 			dataIndex: "pricingPlan",
// 			key: "pricingPlan",
// 			align: "center" as const,
// 		}
// 	];

// 	const rows: RowTransactions[] = [];
// 	Object.keys(data).forEach(key => {
// 		const values = data[key];
// 		rows.push({
// 			key: (rows.length + 1).toString(),
// 			transactionId: values.transactionId,
// 			userId: values.userId,
// 			station: values.station,
// 			chargerId: values.chargerId,
// 			type: values.type,
// 			startTime: values.startTime,
// 			endTime: values.endTime,
// 			energy: (values.energy).toString() + " " + values.energyUnit,
// 			revenue: values.revenue,
// 			pricingPlan: values.pricingPlan
// 		});
// 	});

// 	return {
// 		columns: columns,
// 		rows: rows
// 	};
// };

// export const addZerosToStringNumber = (number: string) => {
// 	const arrNumber = number.split("");
// 	while (arrNumber.length < 4) {
// 		arrNumber.unshift("0");
// 	}
// 	return arrNumber.reduce((previous, current) => previous + current, "");
// };
	}
